import React, { Component, Fragment } from "react";
import { utils } from '../common/utils';
class SocialAccounts extends Component {
    render() {
        const {  representative, shape } = this.props;

        return <Fragment>
            {representative.facebookUrl && (<a rel="noopener noreferrer" className={`social-button shape-${shape} sb-facebook`} href={`${utils.addhttps(representative.facebookUrl)}`} data-toggle="tooltip" data-placement="top" title="" data-original-title="Facebook" target="_blank" >
                <i className="socicon-facebook" />
            </a>)}
            {representative.twitterUrl && (<a rel="noopener noreferrer" className={`social-button shape-${shape} sb-twitter`} href={`${utils.addhttps(representative.twitterUrl)}`} data-toggle="tooltip" data-placement="top" title="" data-original-title="Twitter" target="_blank" >
                <i className="socicon-twitter" />
            </a>)}
            {representative.instagramUrl && (<a rel="noopener noreferrer" className={`social-button shape-${shape} sb-instagram`} href={`${utils.addhttps(representative.instagramUrl)}`} data-toggle="tooltip" data-placement="top" title="" data-original-title="Instagram" target="_blank" >
                <i className="socicon-instagram" />
            </a>)}
            {representative.youtubeUrl && (<a rel="noopener noreferrer" className={`social-button shape-${shape} sb-youtube`} href={`${utils.addhttps(representative.youtubeUrl)}`} data-toggle="tooltip" data-placement="top" title="" data-original-title="Youtube" target="_blank" >
                <i className="socicon-youtube" />
            </a>)}
            {representative.linkedinUrl && (<a rel="noopener noreferrer" className={`social-button shape-${shape} sb-linkedin`} href={`${utils.addhttps(representative.linkedinUrl)}`} data-toggle="tooltip" data-placement="top" title="" data-original-title="LinkedIn" target="_blank" >
                <i className="socicon-linkedin" />
            </a>)}
            {representative.pinterestUrl && (<a rel="noopener noreferrer" className={`social-button shape-${shape} sb-pinterest`} href={`${utils.addhttps(representative.pinterestUrl)}`} data-toggle="tooltip" data-placement="top" title="" data-original-title="Pinterest" target="_blank" >
                <i className="socicon-pinterest" />
            </a>)}

        </Fragment>
    }
}

export default SocialAccounts;
